// ###### IMPORTS
import { useState } from 'react';

// ###### CONSTANTS
const STORAGE_KEY = 'notepad_view_mode';
const DEFAULT_MODE = 'preview';

// ###### CUSTOM HOOK
export const useNotepadViewMode = () => {
  const [viewMode, setViewModeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved || DEFAULT_MODE;
    } catch (error) {
      console.error('Error reading view mode from localStorage:', error);
      return DEFAULT_MODE;
    }
  });

  const setViewMode = (mode) => {
    try {
      setViewModeState(mode);
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      console.error('Error saving view mode to localStorage:', error);
    }
  };

  return { viewMode, setViewMode };
};
